<div class="foreign-product-detail">
    <h2 class="subtitle" [innerHtml]="copyService.copies.foreign_product_detail_subtitle"></h2>
    <form class="form row" [formGroup]="formGroup">
        <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <vcl-form-field [label]="copyService.copies.foreign_product_detail_product_type_label" [msgErr]="copyService.copies.foreign_product_detail_product_type_error">
                <input vclInput id="input-product-type" type="text" [value]="productInfo.product_type"
                    [placeholder]="copyService.copies.foreign_product_detail_product_type_placeholder"
                    (change)="reactiveInputChangeProductType()" formControlName="input-value-product-type">
            </vcl-form-field>
        </div>
        <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <vcl-form-field [label]="copyService.copies.foreign_product_detail_product_id_label" [msgErr]="copyService.copies.foreign_product_detail_product_id_error">
                <input vclInput id="input-product-id" type="number" (keypress)="keyPressInput($event)" [placeholder]="copyService.copies.foreign_product_detail_product_id_placeholder" 
                    [value]="productInfo.product_id" formControlName="input-value-product-id">
            </vcl-form-field>
        </div>

        <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <vcl-form-field [label]="copyService.copies.foreign_product_detail_entity_label" [msgErr]="copyService.copies.foreign_product_detail_entity_error">
                <input vclInput id="input-entity" [placeholder]="copyService.copies.foreign_product_detail_entity_placeholder" 
                    (change)="reactiveInputChangeEntity()" type="text" [value]="productInfo.entity_name" formControlName="input-value-entity">
            </vcl-form-field>
        </div>

        <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <vcl-form-field [label]="copyService.copies.foreign_product_detail_amount_label" [msgErr]="copyService.copies.foreign_product_detail_amount_error">
                <input vclInput id="input-amount" [placeholder]="copyService.copies.foreign_product_detail_amount_placeholder" 
                    voxelMask="currency" [config]="configAmountField" [value]="productInfo.amount" formControlName="input-value-amount">
            </vcl-form-field>
        </div>

        <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <vcl-form-field [label]="copyService.copies.foreign_product_detail_currency_label" [msgErr]="copyService.copies.foreign_product_detail_currency_error">
                <input vclInput id="input-currency" [placeholder]="copyService.copies.foreign_product_detail_currency_placeholder" 
                    type="text" [value]="productInfo.currency" formControlName="input-value-currency">
            </vcl-form-field>
        </div>

        <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <voxel-form-field [label]="copyService.copies.foreign_product_detail_country_label">
                <vcl-autocomplete id="input-country" [placeholder]="copyService.copies.foreign_product_detail_country_placeholder" [notFoundTitle]="copyService.copies.foreign_product_detail_country_not_found_title" [notFoundMessage]="copyService.copies.foreign_product_detail_country_not_found_message" (change)="reactiveInputChangeCountry($event)" required>
                    <vcl-option *ngFor="let option of options" [value]="option" [selected]="selectedCountry === option.description">
                        {{ option.description }}
                    </vcl-option>
                </vcl-autocomplete>
            </voxel-form-field>
        </div>
    </form>
</div>
<app-controls id="foreignProductsDetailBtns" [hasPrevious]="true" [nextLabel]="copyService.copies.foreign_product_detail_button" [nextDisabled]="!formGroup.valid || selectedCountry.country_code == ''" (next)="next()"></app-controls>
